import { translate } from 'src/app/project/features/translate/translate';
import { TDashletGraph } from '../../dashlet-graph.model';
import { generateDoughnutGraphOptions } from './doughnut-graph-options';

export function createCurrentStatusGraph(isMobile: boolean, isExport: boolean): TDashletGraph {
  return {
    type: 'doughnut',
    data: {
      labels: [
        translate('open'),
        translate('in_progress'),
        translate('to_review'),
        translate('on_hold'),
        translate('completed'),
        translate('canceled'),
      ],
      datasets: [
        {
          data: [],
          backgroundColor: ['#3170a7', '#6BC8F9', '#f3db12', '#ff9801', '#65b92e', '#838B99'],
        },
      ],
    },
    options: generateDoughnutGraphOptions(isMobile, isExport),
  };
}
